'use client';

import { Box } from '@wishket/design-system';
import { PropsWithChildren, useEffect, useRef, useState } from 'react';

interface LazyRenderBoxProps extends PropsWithChildren {
  className?: string;
}

const LazyRenderBox = ({ children, className }: LazyRenderBoxProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <Box ref={ref} className={className}>
      {isVisible && children}
    </Box>
  );
};

export default LazyRenderBox;
